import { api } from "@/lib/api";
import { isAudioUnlocked } from "@/lib/chime";

function b64ToUint8(value) {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

let messageBound = false;

// Écoute les messages du service worker : handshake anti-doublon (page visible = gère en interne)
// et navigation au clic sur une notification push.
export function bindServiceWorkerMessages() {
  if (messageBound || !("serviceWorker" in navigator)) return;
  messageBound = true;
  navigator.serviceWorker.addEventListener("message", (event) => {
    const msg = event.data || {};
    if (msg.type === "push-candidate") {
      // La page ne « prend » l'alerte que si elle peut RÉELLEMENT sonner ; sinon la notification
      // système (avec son son) s'affiche — jamais deux sons, dédup par event_id côté page.
      const visible = document.visibilityState === "visible";
      event.ports?.[0]?.postMessage({ handled: visible && isAudioUnlocked() });
    } else if (msg.type === "open-push-url" && msg.url) {
      try { window.location.assign(msg.url); } catch (e) {}
    }
  });
}

// Abonne l'appareil aux Web Push pour le restaurant courant (canal d'alerte de secours,
// État du canal push pour l'indicateur d'en-tête : 'granted' | 'default' | 'denied' | 'unsupported'.
export function getPushState() {
  if (typeof Notification === "undefined" || !("serviceWorker" in navigator) || !("PushManager" in window)) return "unsupported";
  return Notification.permission;
}

// jamais requis pour la réception des données côté app.
export async function enablePush(slug, silent = true) {
  const fail = (reason) => { if (!silent) console.warn("[push]", reason); return { ok: false, reason }; };
  try {
    if (!slug || !("serviceWorker" in navigator) || !("PushManager" in window)) return fail("Navigateur sans Web Push");
    if (typeof Notification === "undefined" || Notification.permission === "denied") return fail("Notifications refusées dans le navigateur");
    if (Notification.permission === "default") {
      if (silent) return fail("Permission non demandée");
      const perm = await Notification.requestPermission();
      if (perm !== "granted") return fail("Permission refusée");
    }
    const { publicKey } = await api.pushVapidKey();
    if (!publicKey) return fail("Clé VAPID absente côté serveur (configuration production)");
    const reg = await navigator.serviceWorker.ready;
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: b64ToUint8(publicKey),
      });
    }
    await api.pushSubscribe({ ...sub.toJSON(), restaurant_slug: slug });
    return { ok: true };
  } catch (e) {
    return fail(e?.response?.data?.detail || e?.message || "Erreur d'abonnement push");
  }
}
